import { ArrowBack } from '@mui/icons-material';
import { IconButton, IconButtonProps } from '@mui/material';

interface BackButtonProps extends Omit<IconButtonProps, 'onClick'> {
  onClick?: () => void;
}

export default function BackButton({ onClick, ...props }: BackButtonProps) {
  if (!onClick) return null;

  return (
    <IconButton onClick={onClick} {...props}>
      <ArrowBack />
    </IconButton>
  );
}
